import React, {useState} from "react";
import Draggable from 'react-draggable'; 
import "../css/deleteWarning.css";
import { useLanguage } from "../components/Language.js";



function DeleteWarningForm({ deleteInfo, onCancel, onConfirm }) {

    const {language} = useLanguage();

    const translations = {
        en: {
            areYouSure: "Are You Sure",
            deleteWarning: "A deletion is irreversible. Are you sure",
            cancel: "Cancel",
            pleaseDelete: "Please Delete this account",
               
        },

        gd: {
            areYouSure: "A bheil thu cinnteach?",
            deleteWarning: "Cha ghabh dubhadh às atharrachadh. A bheil thu dha-rìribh airson an àite seo a dhubhadh às?",
            cancel: "Dubh às",
            pleaseDelete: "Dubh às an cunntas seo, mas e do thoil e",
        },
    };

    return (
    <Draggable>
    <div className = "box">   
        <h2>{translations[language].scrollMore}</h2>
        <p>{translations[language].deleteWarning}</p>
        <div>
            <button id="cancel-location-delete" onClick={onCancel}>{translations[language].cancel}</button>
            <button id="confirm-location-delete" onClick={() => onConfirm(deleteInfo)}>{translations[language].pleaseDelete}</button>
        </div>
    </div>
    </Draggable>
    );
}

export default DeleteWarningForm;